<template>
  <div class="order-source">
    <div class="sub-title">
      <span>订单原始信息</span>
    </div>
    <div class="btn">
      <van-button size="mini" @click="visible = true">查看消息体</van-button>
    </div>
    <van-cell title="订单状态：" :value="sourceInfo.orderStatusText || '--'" />
    <van-cell title="来源：" :value="sourceInfo.shop || '--'" />
    <van-cell title="来源详情：" :value="sourceInfo.sourceName || '--'" />
    <van-cell title="单号：" :value="sourceInfo.orderNo || '--'" />
    <van-cell title="用户ID：" :value="sourceInfo.userId || '--'" />
    <van-cell title="商品名称：" :value="sourceInfo.productName || '--'"/>
    <van-cell title="用户手机：" :value="sourceInfo.userTel || '--'">
      <template v-if="sourceInfo.userTel">
        <a :href="`tel:${sourceInfo.userTel}`">{{ sourceInfo.userTel }}</a>
      </template>
      <span v-else>--</span>
    </van-cell>
    <van-cell title="用户地址：" :value="sourceInfo.userAddress || '--'" />
    <van-cell title="买家备注：" :value="sourceInfo.remark || '--'" />
    <van-cell title="发货状态：" :value="sourceInfo.deliverStatusText || '--'" />
    <van-popup v-model="visible" position="bottom" round :style="{ height: '70%' }">
      <div class="order-source">
        <div class="header border-bottom">
          <van-icon name="cross" @click="visible = false" />
          <span>查看消息体</span>
        </div>
        <div class="content">
          <pre>{{ sourceInfo.content }}</pre>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { otherOrderDetail } from '@/api/order'
export default {
  name: 'orderSource',
  data() {
    return {
      sourceInfo: {},
      visible: false
    }
  },
  created() {
    this.getOrderSourceInfo()
  },
  methods: {
    getOrderSourceInfo() { // 获取订单原始信息
      otherOrderDetail({ orderId: Number(this.$route.query.id) }).then((res) => {
        if (res.errcode === 0) {
          this.sourceInfo = res.data || {}
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.order-source { height: 100%;
  .van-cell { padding: 5px 16px;
    &::after { display: none; } 
  }
  .sub-title { padding: 20px 0 10px 10px; font-size: 16px; color: #323233; background-color: #ebedf0; }
  .btn { margin: 5px 16px;
    .van-button { border: none; font-size: 14px; padding: 0; color: #0000ffc4; }
  }
  .header { padding: 10px 20px; text-align: center; line-height: 30px;
    .van-icon-cross { float: left; cursor: pointer; line-height: 30px; }
  }
  .content { padding: 0 5px; overflow: auto; height: calc(~'100% - 55px'); }
}
</style>